/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsStaffOrdersCtrl
 */
angular.module('mercury.modules.reports.transactions')
.controller('ReportsOrdersTransactionsCtrl', ["ReportsTransactions", "reporttime", "$scope", "$stateParams", "title", function(ReportsTransactions, reporttime, $scope, $stateParams, title) {
  title.set('Orders Transactions View');

  $scope.period = JSON.parse($stateParams.params);

  $scope.showTransactionLines = function(transaction) {
    transaction.visible = !transaction.visible;

    if (!transaction.lines) {
      transaction.lines = ReportsTransactions.getOrdersLines(transaction.posIdentifier);
      transaction.lines.then(function(result) {
        transaction.lines = result;
      });
    }
  };

  $scope.fetchTransactions = function() {
    var loading = ReportsTransactions.getOrdersTransactions($scope.period.start, $scope.period.end);
    loading.then(function(results) {
      $scope.transactionCount = results.length;
      $scope.transactionHeaders = results;
    });
  };
}]);
